import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import HarSanitizerController from './controller';

export default class HarSanitizerRoute extends Route {
  setupController(controller: HarSanitizerController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    if (controller.ticketId == null) {
      for (let originalKey in this.router.currentRoute.queryParams) {
        let key = originalKey.toLowerCase();

        // eslint-disable-next-line spellcheck/spell-checker
        if (key === 'ticketid') {
          controller.ticketId = this.router.currentRoute.queryParams[originalKey] ?? null;
          break;
        }
      }
    }
  }
}
